import SupportBundlePackManagerPage from './SupportBundlePackManagerPage'

export default function SupportClinicBrandBundlePacksPage() {
  return <SupportBundlePackManagerPage scopeType="clinic-brand" />
}
